/**
 * Get the CSRF token from the meta tag
 */
export function getCsrfToken(): string {
  return (
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ""
  );
}

/**
 * Fetch wrapper that automatically includes CSRF token
 */
export async function fetchWithCsrf(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const headers = new Headers(options.headers);

  // Add CSRF token if not already present
  if (!headers.has("X-CSRF-Token")) {
    headers.set("X-CSRF-Token", getCsrfToken());
  }

  // Add Content-Type if not present and there's a body
  if (options.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
